/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as KeysRouteImport } from './routes/keys'
import { Route as LogsRouteImport } from './routes/logs'
import { Route as MailboxesRouteImport } from './routes/mailboxes'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as SandboxRouteImport } from './routes/sandbox'
import { Route as SegmentsRouteImport } from './routes/segments'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SuppressionsRouteImport } from './routes/suppressions'
import { Route as TeamRouteImport } from './routes/team'
import { Route as TopicsRouteImport } from './routes/topics'
import { Route as WebhooksRouteImport } from './routes/webhooks'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminHealthRouteImport } from './routes/admin/health'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminUsageRouteImport } from './routes/admin/usage'
import { Route as AutomationsIndexRouteImport } from './routes/automations/index'
import { Route as AutomationsIdRouteImport } from './routes/automations/$id'
import { Route as BroadcastsIndexRouteImport } from './routes/broadcasts/index'
import { Route as BroadcastsIdRouteImport } from './routes/broadcasts/$id'
import { Route as ContactsIndexRouteImport } from './routes/contacts/index'
import { Route as ContactsIdRouteImport } from './routes/contacts/$id'
import { Route as DomainsIndexRouteImport } from './routes/domains/index'
import { Route as DomainsIdRouteImport } from './routes/domains/$id'
import { Route as EmailsIndexRouteImport } from './routes/emails/index'
import { Route as EmailsIdRouteImport } from './routes/emails/$id'
import { Route as InboundIndexRouteImport } from './routes/inbound/index'
import { Route as InboundIdRouteImport } from './routes/inbound/$id'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingCloudflareRouteImport } from './routes/onboarding/cloudflare'
import { Route as OnboardingContactsRouteImport } from './routes/onboarding/contacts'
import { Route as OnboardingDomainRouteImport } from './routes/onboarding/domain'
import { Route as OnboardingInboundRouteImport } from './routes/onboarding/inbound'
import { Route as OnboardingKeysRouteImport } from './routes/onboarding/keys'
import { Route as OnboardingMailboxesRouteImport } from './routes/onboarding/mailboxes'
import { Route as OnboardingOrganizationRouteImport } from './routes/onboarding/organization'
import { Route as OnboardingProjectRouteImport } from './routes/onboarding/project'
import { Route as OnboardingTestRouteImport } from './routes/onboarding/test'
import { Route as OnboardingWebhooksRouteImport } from './routes/onboarding/webhooks'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsCloudflareRouteImport } from './routes/settings/cloudflare'
import { Route as SettingsOauthRouteImport } from './routes/settings/oauth'
import { Route as SettingsOrganizationRouteImport } from './routes/settings/organization'
import { Route as SettingsProjectsRouteImport } from './routes/settings/projects'
import { Route as SettingsSessionsRouteImport } from './routes/settings/sessions'
import { Route as SettingsSmtpRouteImport } from './routes/settings/smtp'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TemplatesIdRouteImport } from './routes/templates/$id'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations/index'
import { Route as AdminOrganizationsOrgIdRouteImport } from './routes/admin/organizations/$orgId'
import { Route as AdminSupportIndexRouteImport } from './routes/admin/support/index'
import { Route as AdminSupportTicketIdRouteImport } from './routes/admin/support/$ticketId'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users/$userId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsRoute = AlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const KeysRoute = KeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => rootRouteImport,
} as any)
const LogsRoute = LogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => rootRouteImport,
} as any)
const MailboxesRoute = MailboxesRouteImport.update({
  id: '/mailboxes',
  path: '/mailboxes',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SandboxRoute = SandboxRouteImport.update({
  id: '/sandbox',
  path: '/sandbox',
  getParentRoute: () => rootRouteImport,
} as any)
const SegmentsRoute = SegmentsRouteImport.update({
  id: '/segments',
  path: '/segments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppressionsRoute = SuppressionsRouteImport.update({
  id: '/suppressions',
  path: '/suppressions',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const TopicsRoute = TopicsRouteImport.update({
  id: '/topics',
  path: '/topics',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhooksRoute = WebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/admin/health',
  path: '/admin/health',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsageRoute = AdminUsageRouteImport.update({
  id: '/admin/usage',
  path: '/admin/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationsIndexRoute = AutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationsIdRoute = AutomationsIdRouteImport.update({
  id: '/automations/$id',
  path: '/automations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BroadcastsIndexRoute = BroadcastsIndexRouteImport.update({
  id: '/broadcasts/',
  path: '/broadcasts/',
  getParentRoute: () => rootRouteImport,
} as any)
const BroadcastsIdRoute = BroadcastsIdRouteImport.update({
  id: '/broadcasts/$id',
  path: '/broadcasts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsIndexRoute = ContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsIdRoute = ContactsIdRouteImport.update({
  id: '/contacts/$id',
  path: '/contacts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DomainsIndexRoute = DomainsIndexRouteImport.update({
  id: '/domains/',
  path: '/domains/',
  getParentRoute: () => rootRouteImport,
} as any)
const DomainsIdRoute = DomainsIdRouteImport.update({
  id: '/domains/$id',
  path: '/domains/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsIndexRoute = EmailsIndexRouteImport.update({
  id: '/emails/',
  path: '/emails/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsIdRoute = EmailsIdRouteImport.update({
  id: '/emails/$id',
  path: '/emails/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InboundIndexRoute = InboundIndexRouteImport.update({
  id: '/inbound/',
  path: '/inbound/',
  getParentRoute: () => rootRouteImport,
} as any)
const InboundIdRoute = InboundIdRouteImport.update({
  id: '/inbound/$id',
  path: '/inbound/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingCloudflareRoute = OnboardingCloudflareRouteImport.update({
  id: '/cloudflare',
  path: '/cloudflare',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingContactsRoute = OnboardingContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingDomainRoute = OnboardingDomainRouteImport.update({
  id: '/domain',
  path: '/domain',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingInboundRoute = OnboardingInboundRouteImport.update({
  id: '/inbound',
  path: '/inbound',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingKeysRoute = OnboardingKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingMailboxesRoute = OnboardingMailboxesRouteImport.update({
  id: '/mailboxes',
  path: '/mailboxes',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingOrganizationRoute = OnboardingOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingProjectRoute = OnboardingProjectRouteImport.update({
  id: '/project',
  path: '/project',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingTestRoute = OnboardingTestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingWebhooksRoute = OnboardingWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsCloudflareRoute = SettingsCloudflareRouteImport.update({
  id: '/cloudflare',
  path: '/cloudflare',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsOauthRoute = SettingsOauthRouteImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsProjectsRoute = SettingsProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSessionsRoute = SettingsSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSmtpRoute = SettingsSmtpRouteImport.update({
  id: '/smtp',
  path: '/smtp',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIdRoute = TemplatesIdRouteImport.update({
  id: '/templates/$id',
  path: '/templates/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/admin/organizations/',
  path: '/admin/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationsOrgIdRoute = AdminOrganizationsOrgIdRouteImport.update({
  id: '/admin/organizations/$orgId',
  path: '/admin/organizations/$orgId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSupportIndexRoute = AdminSupportIndexRouteImport.update({
  id: '/admin/support/',
  path: '/admin/support/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSupportTicketIdRoute = AdminSupportTicketIdRouteImport.update({
  id: '/admin/support/$ticketId',
  path: '/admin/support/$ticketId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/admin/users/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/alerts': typeof AlertsRoute
  '/audit': typeof AuditRoute
  '/keys': typeof KeysRoute
  '/logs': typeof LogsRoute
  '/mailboxes': typeof MailboxesRoute
  '/sandbox': typeof SandboxRoute
  '/segments': typeof SegmentsRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/status': typeof StatusRoute
  '/suppressions': typeof SuppressionsRoute
  '/team': typeof TeamRoute
  '/topics': typeof TopicsRoute
  '/webhooks': typeof WebhooksRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/usage': typeof AdminUsageRoute
  '/automations/$id': typeof AutomationsIdRoute
  '/broadcasts/$id': typeof BroadcastsIdRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/domains/$id': typeof DomainsIdRoute
  '/emails/$id': typeof EmailsIdRoute
  '/inbound/$id': typeof InboundIdRoute
  '/onboarding/cloudflare': typeof OnboardingCloudflareRoute
  '/onboarding/contacts': typeof OnboardingContactsRoute
  '/onboarding/domain': typeof OnboardingDomainRoute
  '/onboarding/inbound': typeof OnboardingInboundRoute
  '/onboarding/keys': typeof OnboardingKeysRoute
  '/onboarding/mailboxes': typeof OnboardingMailboxesRoute
  '/onboarding/organization': typeof OnboardingOrganizationRoute
  '/onboarding/project': typeof OnboardingProjectRoute
  '/onboarding/test': typeof OnboardingTestRoute
  '/onboarding/webhooks': typeof OnboardingWebhooksRoute
  '/settings/cloudflare': typeof SettingsCloudflareRoute
  '/settings/oauth': typeof SettingsOauthRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/sessions': typeof SettingsSessionsRoute
  '/settings/smtp': typeof SettingsSmtpRoute
  '/templates/$id': typeof TemplatesIdRoute
  '/admin/': typeof AdminIndexRoute
  '/automations/': typeof AutomationsIndexRoute
  '/broadcasts/': typeof BroadcastsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/domains/': typeof DomainsIndexRoute
  '/emails/': typeof EmailsIndexRoute
  '/inbound/': typeof InboundIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/support/': typeof AdminSupportIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/alerts': typeof AlertsRoute
  '/audit': typeof AuditRoute
  '/keys': typeof KeysRoute
  '/logs': typeof LogsRoute
  '/mailboxes': typeof MailboxesRoute
  '/sandbox': typeof SandboxRoute
  '/segments': typeof SegmentsRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/status': typeof StatusRoute
  '/suppressions': typeof SuppressionsRoute
  '/team': typeof TeamRoute
  '/topics': typeof TopicsRoute
  '/webhooks': typeof WebhooksRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/usage': typeof AdminUsageRoute
  '/automations/$id': typeof AutomationsIdRoute
  '/broadcasts/$id': typeof BroadcastsIdRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/domains/$id': typeof DomainsIdRoute
  '/emails/$id': typeof EmailsIdRoute
  '/inbound/$id': typeof InboundIdRoute
  '/onboarding/cloudflare': typeof OnboardingCloudflareRoute
  '/onboarding/contacts': typeof OnboardingContactsRoute
  '/onboarding/domain': typeof OnboardingDomainRoute
  '/onboarding/inbound': typeof OnboardingInboundRoute
  '/onboarding/keys': typeof OnboardingKeysRoute
  '/onboarding/mailboxes': typeof OnboardingMailboxesRoute
  '/onboarding/organization': typeof OnboardingOrganizationRoute
  '/onboarding/project': typeof OnboardingProjectRoute
  '/onboarding/test': typeof OnboardingTestRoute
  '/onboarding/webhooks': typeof OnboardingWebhooksRoute
  '/settings/cloudflare': typeof SettingsCloudflareRoute
  '/settings/oauth': typeof SettingsOauthRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/sessions': typeof SettingsSessionsRoute
  '/settings/smtp': typeof SettingsSmtpRoute
  '/templates/$id': typeof TemplatesIdRoute
  '/admin': typeof AdminIndexRoute
  '/automations': typeof AutomationsIndexRoute
  '/broadcasts': typeof BroadcastsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/domains': typeof DomainsIndexRoute
  '/emails': typeof EmailsIndexRoute
  '/inbound': typeof InboundIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/support': typeof AdminSupportIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/alerts': typeof AlertsRoute
  '/audit': typeof AuditRoute
  '/keys': typeof KeysRoute
  '/logs': typeof LogsRoute
  '/mailboxes': typeof MailboxesRoute
  '/sandbox': typeof SandboxRoute
  '/segments': typeof SegmentsRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/status': typeof StatusRoute
  '/suppressions': typeof SuppressionsRoute
  '/team': typeof TeamRoute
  '/topics': typeof TopicsRoute
  '/webhooks': typeof WebhooksRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/health': typeof AdminHealthRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/usage': typeof AdminUsageRoute
  '/automations/$id': typeof AutomationsIdRoute
  '/broadcasts/$id': typeof BroadcastsIdRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/domains/$id': typeof DomainsIdRoute
  '/emails/$id': typeof EmailsIdRoute
  '/inbound/$id': typeof InboundIdRoute
  '/onboarding/cloudflare': typeof OnboardingCloudflareRoute
  '/onboarding/contacts': typeof OnboardingContactsRoute
  '/onboarding/domain': typeof OnboardingDomainRoute
  '/onboarding/inbound': typeof OnboardingInboundRoute
  '/onboarding/keys': typeof OnboardingKeysRoute
  '/onboarding/mailboxes': typeof OnboardingMailboxesRoute
  '/onboarding/organization': typeof OnboardingOrganizationRoute
  '/onboarding/project': typeof OnboardingProjectRoute
  '/onboarding/test': typeof OnboardingTestRoute
  '/onboarding/webhooks': typeof OnboardingWebhooksRoute
  '/settings/cloudflare': typeof SettingsCloudflareRoute
  '/settings/oauth': typeof SettingsOauthRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/projects': typeof SettingsProjectsRoute
  '/settings/sessions': typeof SettingsSessionsRoute
  '/settings/smtp': typeof SettingsSmtpRoute
  '/templates/$id': typeof TemplatesIdRoute
  '/admin/': typeof AdminIndexRoute
  '/automations/': typeof AutomationsIndexRoute
  '/broadcasts/': typeof BroadcastsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/domains/': typeof DomainsIndexRoute
  '/emails/': typeof EmailsIndexRoute
  '/inbound/': typeof InboundIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/support/': typeof AdminSupportIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/settings'
    | '/alerts'
    | '/audit'
    | '/keys'
    | '/logs'
    | '/mailboxes'
    | '/sandbox'
    | '/segments'
    | '/signin'
    | '/signup'
    | '/status'
    | '/suppressions'
    | '/team'
    | '/topics'
    | '/webhooks'
    | '/admin/audit'
    | '/admin/health'
    | '/admin/settings'
    | '/admin/usage'
    | '/automations/$id'
    | '/broadcasts/$id'
    | '/contacts/$id'
    | '/domains/$id'
    | '/emails/$id'
    | '/inbound/$id'
    | '/onboarding/cloudflare'
    | '/onboarding/contacts'
    | '/onboarding/domain'
    | '/onboarding/inbound'
    | '/onboarding/keys'
    | '/onboarding/mailboxes'
    | '/onboarding/organization'
    | '/onboarding/project'
    | '/onboarding/test'
    | '/onboarding/webhooks'
    | '/settings/cloudflare'
    | '/settings/oauth'
    | '/settings/organization'
    | '/settings/projects'
    | '/settings/sessions'
    | '/settings/smtp'
    | '/templates/$id'
    | '/admin/'
    | '/automations/'
    | '/broadcasts/'
    | '/contacts/'
    | '/domains/'
    | '/emails/'
    | '/inbound/'
    | '/onboarding/'
    | '/settings/'
    | '/templates/'
    | '/admin/organizations/$orgId'
    | '/admin/support/$ticketId'
    | '/admin/users/$userId'
    | '/admin/organizations/'
    | '/admin/support/'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/alerts'
    | '/audit'
    | '/keys'
    | '/logs'
    | '/mailboxes'
    | '/sandbox'
    | '/segments'
    | '/signin'
    | '/signup'
    | '/status'
    | '/suppressions'
    | '/team'
    | '/topics'
    | '/webhooks'
    | '/admin/audit'
    | '/admin/health'
    | '/admin/settings'
    | '/admin/usage'
    | '/automations/$id'
    | '/broadcasts/$id'
    | '/contacts/$id'
    | '/domains/$id'
    | '/emails/$id'
    | '/inbound/$id'
    | '/onboarding/cloudflare'
    | '/onboarding/contacts'
    | '/onboarding/domain'
    | '/onboarding/inbound'
    | '/onboarding/keys'
    | '/onboarding/mailboxes'
    | '/onboarding/organization'
    | '/onboarding/project'
    | '/onboarding/test'
    | '/onboarding/webhooks'
    | '/settings/cloudflare'
    | '/settings/oauth'
    | '/settings/organization'
    | '/settings/projects'
    | '/settings/sessions'
    | '/settings/smtp'
    | '/templates/$id'
    | '/admin'
    | '/automations'
    | '/broadcasts'
    | '/contacts'
    | '/domains'
    | '/emails'
    | '/inbound'
    | '/onboarding'
    | '/settings'
    | '/templates'
    | '/admin/organizations/$orgId'
    | '/admin/support/$ticketId'
    | '/admin/users/$userId'
    | '/admin/organizations'
    | '/admin/support'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/onboarding'
    | '/settings'
    | '/alerts'
    | '/audit'
    | '/keys'
    | '/logs'
    | '/mailboxes'
    | '/sandbox'
    | '/segments'
    | '/signin'
    | '/signup'
    | '/status'
    | '/suppressions'
    | '/team'
    | '/topics'
    | '/webhooks'
    | '/admin/audit'
    | '/admin/health'
    | '/admin/settings'
    | '/admin/usage'
    | '/automations/$id'
    | '/broadcasts/$id'
    | '/contacts/$id'
    | '/domains/$id'
    | '/emails/$id'
    | '/inbound/$id'
    | '/onboarding/cloudflare'
    | '/onboarding/contacts'
    | '/onboarding/domain'
    | '/onboarding/inbound'
    | '/onboarding/keys'
    | '/onboarding/mailboxes'
    | '/onboarding/organization'
    | '/onboarding/project'
    | '/onboarding/test'
    | '/onboarding/webhooks'
    | '/settings/cloudflare'
    | '/settings/oauth'
    | '/settings/organization'
    | '/settings/projects'
    | '/settings/sessions'
    | '/settings/smtp'
    | '/templates/$id'
    | '/admin/'
    | '/automations/'
    | '/broadcasts/'
    | '/contacts/'
    | '/domains/'
    | '/emails/'
    | '/inbound/'
    | '/onboarding/'
    | '/settings/'
    | '/templates/'
    | '/admin/organizations/$orgId'
    | '/admin/support/$ticketId'
    | '/admin/users/$userId'
    | '/admin/organizations/'
    | '/admin/support/'
    | '/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  AlertsRoute: typeof AlertsRoute
  AuditRoute: typeof AuditRoute
  KeysRoute: typeof KeysRoute
  LogsRoute: typeof LogsRoute
  MailboxesRoute: typeof MailboxesRoute
  SandboxRoute: typeof SandboxRoute
  SegmentsRoute: typeof SegmentsRoute
  SigninRoute: typeof SigninRoute
  SignupRoute: typeof SignupRoute
  StatusRoute: typeof StatusRoute
  SuppressionsRoute: typeof SuppressionsRoute
  TeamRoute: typeof TeamRoute
  TopicsRoute: typeof TopicsRoute
  WebhooksRoute: typeof WebhooksRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminHealthRoute: typeof AdminHealthRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUsageRoute: typeof AdminUsageRoute
  AutomationsIdRoute: typeof AutomationsIdRoute
  BroadcastsIdRoute: typeof BroadcastsIdRoute
  ContactsIdRoute: typeof ContactsIdRoute
  DomainsIdRoute: typeof DomainsIdRoute
  EmailsIdRoute: typeof EmailsIdRoute
  InboundIdRoute: typeof InboundIdRoute
  TemplatesIdRoute: typeof TemplatesIdRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AutomationsIndexRoute: typeof AutomationsIndexRoute
  BroadcastsIndexRoute: typeof BroadcastsIndexRoute
  ContactsIndexRoute: typeof ContactsIndexRoute
  DomainsIndexRoute: typeof DomainsIndexRoute
  EmailsIndexRoute: typeof EmailsIndexRoute
  InboundIndexRoute: typeof InboundIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  AdminOrganizationsOrgIdRoute: typeof AdminOrganizationsOrgIdRoute
  AdminSupportTicketIdRoute: typeof AdminSupportTicketIdRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
  AdminSupportIndexRoute: typeof AdminSupportIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts': {
      id: '/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/keys': {
      id: '/keys'
      path: '/keys'
      fullPath: '/keys'
      preLoaderRoute: typeof KeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logs': {
      id: '/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof LogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mailboxes': {
      id: '/mailboxes'
      path: '/mailboxes'
      fullPath: '/mailboxes'
      preLoaderRoute: typeof MailboxesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sandbox': {
      id: '/sandbox'
      path: '/sandbox'
      fullPath: '/sandbox'
      preLoaderRoute: typeof SandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/segments': {
      id: '/segments'
      path: '/segments'
      fullPath: '/segments'
      preLoaderRoute: typeof SegmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppressions': {
      id: '/suppressions'
      path: '/suppressions'
      fullPath: '/suppressions'
      preLoaderRoute: typeof SuppressionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/topics': {
      id: '/topics'
      path: '/topics'
      fullPath: '/topics'
      preLoaderRoute: typeof TopicsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhooks': {
      id: '/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof WebhooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/admin/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/usage': {
      id: '/admin/usage'
      path: '/admin/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AdminUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/': {
      id: '/automations/'
      path: '/automations'
      fullPath: '/automations/'
      preLoaderRoute: typeof AutomationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/$id': {
      id: '/automations/$id'
      path: '/automations/$id'
      fullPath: '/automations/$id'
      preLoaderRoute: typeof AutomationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/broadcasts/': {
      id: '/broadcasts/'
      path: '/broadcasts'
      fullPath: '/broadcasts/'
      preLoaderRoute: typeof BroadcastsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/broadcasts/$id': {
      id: '/broadcasts/$id'
      path: '/broadcasts/$id'
      fullPath: '/broadcasts/$id'
      preLoaderRoute: typeof BroadcastsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/': {
      id: '/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof ContactsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/$id': {
      id: '/contacts/$id'
      path: '/contacts/$id'
      fullPath: '/contacts/$id'
      preLoaderRoute: typeof ContactsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/domains/': {
      id: '/domains/'
      path: '/domains'
      fullPath: '/domains/'
      preLoaderRoute: typeof DomainsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/domains/$id': {
      id: '/domains/$id'
      path: '/domains/$id'
      fullPath: '/domains/$id'
      preLoaderRoute: typeof DomainsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/': {
      id: '/emails/'
      path: '/emails'
      fullPath: '/emails/'
      preLoaderRoute: typeof EmailsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/$id': {
      id: '/emails/$id'
      path: '/emails/$id'
      fullPath: '/emails/$id'
      preLoaderRoute: typeof EmailsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbound/': {
      id: '/inbound/'
      path: '/inbound'
      fullPath: '/inbound/'
      preLoaderRoute: typeof InboundIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbound/$id': {
      id: '/inbound/$id'
      path: '/inbound/$id'
      fullPath: '/inbound/$id'
      preLoaderRoute: typeof InboundIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/cloudflare': {
      id: '/onboarding/cloudflare'
      path: '/cloudflare'
      fullPath: '/onboarding/cloudflare'
      preLoaderRoute: typeof OnboardingCloudflareRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/contacts': {
      id: '/onboarding/contacts'
      path: '/contacts'
      fullPath: '/onboarding/contacts'
      preLoaderRoute: typeof OnboardingContactsRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/domain': {
      id: '/onboarding/domain'
      path: '/domain'
      fullPath: '/onboarding/domain'
      preLoaderRoute: typeof OnboardingDomainRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/inbound': {
      id: '/onboarding/inbound'
      path: '/inbound'
      fullPath: '/onboarding/inbound'
      preLoaderRoute: typeof OnboardingInboundRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/keys': {
      id: '/onboarding/keys'
      path: '/keys'
      fullPath: '/onboarding/keys'
      preLoaderRoute: typeof OnboardingKeysRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/mailboxes': {
      id: '/onboarding/mailboxes'
      path: '/mailboxes'
      fullPath: '/onboarding/mailboxes'
      preLoaderRoute: typeof OnboardingMailboxesRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/organization': {
      id: '/onboarding/organization'
      path: '/organization'
      fullPath: '/onboarding/organization'
      preLoaderRoute: typeof OnboardingOrganizationRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/project': {
      id: '/onboarding/project'
      path: '/project'
      fullPath: '/onboarding/project'
      preLoaderRoute: typeof OnboardingProjectRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/test': {
      id: '/onboarding/test'
      path: '/test'
      fullPath: '/onboarding/test'
      preLoaderRoute: typeof OnboardingTestRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/webhooks': {
      id: '/onboarding/webhooks'
      path: '/webhooks'
      fullPath: '/onboarding/webhooks'
      preLoaderRoute: typeof OnboardingWebhooksRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/cloudflare': {
      id: '/settings/cloudflare'
      path: '/cloudflare'
      fullPath: '/settings/cloudflare'
      preLoaderRoute: typeof SettingsCloudflareRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/oauth': {
      id: '/settings/oauth'
      path: '/oauth'
      fullPath: '/settings/oauth'
      preLoaderRoute: typeof SettingsOauthRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/organization': {
      id: '/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/projects': {
      id: '/settings/projects'
      path: '/projects'
      fullPath: '/settings/projects'
      preLoaderRoute: typeof SettingsProjectsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/sessions': {
      id: '/settings/sessions'
      path: '/sessions'
      fullPath: '/settings/sessions'
      preLoaderRoute: typeof SettingsSessionsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/smtp': {
      id: '/settings/smtp'
      path: '/smtp'
      fullPath: '/settings/smtp'
      preLoaderRoute: typeof SettingsSmtpRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/$id': {
      id: '/templates/$id'
      path: '/templates/$id'
      fullPath: '/templates/$id'
      preLoaderRoute: typeof TemplatesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/admin/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organizations/$orgId': {
      id: '/admin/organizations/$orgId'
      path: '/admin/organizations/$orgId'
      fullPath: '/admin/organizations/$orgId'
      preLoaderRoute: typeof AdminOrganizationsOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/support/': {
      id: '/admin/support/'
      path: '/admin/support'
      fullPath: '/admin/support/'
      preLoaderRoute: typeof AdminSupportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/support/$ticketId': {
      id: '/admin/support/$ticketId'
      path: '/admin/support/$ticketId'
      fullPath: '/admin/support/$ticketId'
      preLoaderRoute: typeof AdminSupportTicketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface OnboardingRouteRouteChildren {
  OnboardingCloudflareRoute: typeof OnboardingCloudflareRoute
  OnboardingContactsRoute: typeof OnboardingContactsRoute
  OnboardingDomainRoute: typeof OnboardingDomainRoute
  OnboardingInboundRoute: typeof OnboardingInboundRoute
  OnboardingKeysRoute: typeof OnboardingKeysRoute
  OnboardingMailboxesRoute: typeof OnboardingMailboxesRoute
  OnboardingOrganizationRoute: typeof OnboardingOrganizationRoute
  OnboardingProjectRoute: typeof OnboardingProjectRoute
  OnboardingTestRoute: typeof OnboardingTestRoute
  OnboardingWebhooksRoute: typeof OnboardingWebhooksRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingCloudflareRoute: OnboardingCloudflareRoute,
  OnboardingContactsRoute: OnboardingContactsRoute,
  OnboardingDomainRoute: OnboardingDomainRoute,
  OnboardingInboundRoute: OnboardingInboundRoute,
  OnboardingKeysRoute: OnboardingKeysRoute,
  OnboardingMailboxesRoute: OnboardingMailboxesRoute,
  OnboardingOrganizationRoute: OnboardingOrganizationRoute,
  OnboardingProjectRoute: OnboardingProjectRoute,
  OnboardingTestRoute: OnboardingTestRoute,
  OnboardingWebhooksRoute: OnboardingWebhooksRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsCloudflareRoute: typeof SettingsCloudflareRoute
  SettingsOauthRoute: typeof SettingsOauthRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  SettingsProjectsRoute: typeof SettingsProjectsRoute
  SettingsSessionsRoute: typeof SettingsSessionsRoute
  SettingsSmtpRoute: typeof SettingsSmtpRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsCloudflareRoute: SettingsCloudflareRoute,
  SettingsOauthRoute: SettingsOauthRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  SettingsProjectsRoute: SettingsProjectsRoute,
  SettingsSessionsRoute: SettingsSessionsRoute,
  SettingsSmtpRoute: SettingsSmtpRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  AlertsRoute: AlertsRoute,
  AuditRoute: AuditRoute,
  KeysRoute: KeysRoute,
  LogsRoute: LogsRoute,
  MailboxesRoute: MailboxesRoute,
  SandboxRoute: SandboxRoute,
  SegmentsRoute: SegmentsRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  StatusRoute: StatusRoute,
  SuppressionsRoute: SuppressionsRoute,
  TeamRoute: TeamRoute,
  TopicsRoute: TopicsRoute,
  WebhooksRoute: WebhooksRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminHealthRoute: AdminHealthRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUsageRoute: AdminUsageRoute,
  AutomationsIdRoute: AutomationsIdRoute,
  BroadcastsIdRoute: BroadcastsIdRoute,
  ContactsIdRoute: ContactsIdRoute,
  DomainsIdRoute: DomainsIdRoute,
  EmailsIdRoute: EmailsIdRoute,
  InboundIdRoute: InboundIdRoute,
  TemplatesIdRoute: TemplatesIdRoute,
  AdminIndexRoute: AdminIndexRoute,
  AutomationsIndexRoute: AutomationsIndexRoute,
  BroadcastsIndexRoute: BroadcastsIndexRoute,
  ContactsIndexRoute: ContactsIndexRoute,
  DomainsIndexRoute: DomainsIndexRoute,
  EmailsIndexRoute: EmailsIndexRoute,
  InboundIndexRoute: InboundIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  AdminOrganizationsOrgIdRoute: AdminOrganizationsOrgIdRoute,
  AdminSupportTicketIdRoute: AdminSupportTicketIdRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
  AdminSupportIndexRoute: AdminSupportIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
